import Link from 'next/link'
import ToastyLogo from '../ToastyLogo'

export const MarketingFooter = () => {
  return (
    <footer className="w-full bg-slate-800 py-12 text-white">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-5">
          {/* Logo and Description Column */}
          <div className="sm:pt-4 md:col-span-1">
            <ToastyLogo
              href="https://outcast.ai"
              color="white"
              className="!h-5 !w-auto"
            />
            <p className="mt-6 text-[15px] font-medium text-white">
              Outcast automates your content creation and repurposing workflows
              with advanced AI tools.
            </p>
          </div>

          {/* Features Column */}
          <div className="md:col-span-1">
            <h3 className="mb-4 font-semibold">Features</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://outcast.ai/transcripts"
                  className="text-gray-400 hover:text-white"
                >
                  Transcription
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/ai-studio"
                  className="text-gray-400 hover:text-white"
                >
                  AI Studio
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/clips"
                  className="text-gray-400 hover:text-white"
                >
                  Clip Studio
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/chatbots"
                  className="text-gray-400 hover:text-white"
                >
                  Chatbots
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/prompt-packs"
                  className="text-gray-400 hover:text-white"
                >
                  Prompt Packs
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/projects-and-teams"
                  className="text-gray-400 hover:text-white"
                >
                  For Teams
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/outcastgpt"
                  className="text-gray-400 hover:text-white"
                >
                  OutcastGPT
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="md:col-span-1">
            <h3 className="mb-4 font-semibold">Company</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://outcast.ai/pricing"
                  className="text-gray-400 hover:text-white"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/mission"
                  className="text-gray-400 hover:text-white"
                >
                  Mission
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/changelog"
                  className="text-gray-400 hover:text-white"
                >
                  Changelog
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/blog"
                  className="text-gray-400 hover:text-white"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.getrewardful.com/signup"
                  className="text-gray-400 hover:text-white"
                >
                  Affiliate Program
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/glossary"
                  className="text-gray-400 hover:text-white"
                >
                  Glossary
                </a>
              </li>
              <li>
                <a
                  href="https://outcast.ai/contact"
                  className="text-gray-400 hover:text-white"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-1">
            <h3 className="mb-4 font-semibold">Use Cases</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/use-cases/podcaster"
                  className="text-gray-400 hover:text-white"
                >
                  Podcaster
                </Link>
              </li>
              <li>
                <Link
                  href="/use-cases/youtuber"
                  className="text-gray-400 hover:text-white"
                >
                  YouTuber
                </Link>
              </li>
              <li>
                <Link
                  href="/use-cases/meeting"
                  className="text-gray-400 hover:text-white"
                >
                  Meeting
                </Link>
              </li>
              <li>
                <Link
                  href="/use-cases/interview"
                  className="text-gray-400 hover:text-white"
                >
                  Interview
                </Link>
              </li>
              <li>
                <Link
                  href="/use-cases/coaching-session"
                  className="text-gray-400 hover:text-white"
                >
                  Coaching Session
                </Link>
              </li>
              <li>
                <Link
                  href="/use-cases/keynote"
                  className="text-gray-400 hover:text-white"
                >
                  Keynote
                </Link>
              </li>
            </ul>
          </div>

          {/* Empty column to maintain grid layout */}
          <div className="md:col-span-1"></div>
        </div>

        <div className="mt-12 border-t border-gray-700 pt-8">
          <div className="flex flex-col justify-between gap-4 md:flex-row md:items-center">
            <p className="text-sm text-gray-400">
              Copyright © {new Date().getFullYear()} Outcast.ai. All Rights
              Reserved.
            </p>
            <div className="flex gap-8">
              <a
                href="https://outcast.ai/privacy-policy"
                className="text-sm text-gray-400 hover:text-white"
              >
                Privacy Policy
              </a>
              <a
                href="https://outcast.ai/terms-conditions"
                className="text-sm text-gray-400 hover:text-white"
              >
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
